import useAccountingTableColumns from "./hooks/useAccountingTableColumns";
import { useSetupFooter } from "views/Setup/context/SetupFooterContext";
import CreateUpdateVat from "./components/CreateUpdateVat";
import { useGetWindowHeight } from "@neonumy/neonumy-ui";
import React, { useEffect, useState } from "react";
import { TableFilter } from "@neonumy/ant-design";
import ClientVatTypes from "../ClientVatTypes";
import { useTranslation } from "react-i18next";
import { FaPercentage } from "react-icons/fa";
import { useParams } from "react-router-dom";
import CardTitle from "components/CardTitle";
import useVatsApi from "./hooks/useVatsApi";
import { Card, Col, Row } from "antd";
interface VatsPropsTypes {
  nextButton?: () => void;
  prevButton?: () => void;
  isSetup?: boolean;
}
export default function Vats(props: VatsPropsTypes): React.ReactElement {
  const windowHeight = useGetWindowHeight();
  const paginationInit = {
    offset: 0,
    limit: 10,
  };
  const { nextButton, isSetup } = props;
  const { t } = useTranslation();
  const urlParams: RouteParams = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const {
    listVatsRefetch: refetch,
    listVatsLoading: loading,
    listVatsTotalCount: totalCount,
    listVatsData: dataSource,
    listVats,
  } = useVatsApi(urlParams.clientId);

  const COLUMNS = useAccountingTableColumns(dataSource, refetch);

  useSetupFooter(isSetup ? { onSave: nextButton!, loading } : null);

  useEffect(() => {
    listVats({
      variables: {
        filter: {
          companyId: urlParams?.companyId,
        },
        ...paginationInit,
        orderBy: ["rate"],
      },
    });
  }, []);

  const handlePagination = (page: number, size: number) => {
    setPageSize(size);
    setCurrentPage(page);
    refetch({
      limit: size,
      offset: size * (page - 1),
    });
  };

  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Card
            title={<CardTitle icon={<FaPercentage />} title={t("VAT")} />}
            className="antd-newrai-card no-border-top-left"
          >
            <TableFilter
              className="antd-newrai-table"
              size="small"
              scroll={{ y: windowHeight - 550 }}
              dataSource={dataSource}
              loading={loading}
              columns={COLUMNS}
              pagination={{
                onChange: handlePagination,
                showSizeChanger: true,
                current: currentPage,
                pageSize: pageSize,
                total: totalCount,
                showTotal: total => t("Total table items", { count: total }),
              }}
              debounced={true}
            />
            <CreateUpdateVat refetch={refetch} />
          </Card>
        </Col>
        <Col span={12}>
          <ClientVatTypes />
        </Col>
      </Row>
    </>
  );
}
